import Cookies from "js-cookie";
import { saveForConversionTracking } from "../../utils";
import {
  handleCardHover,
  handleSwatchClick,
  productCardTemplate,
} from "./product-card";

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, results, widgetParams } = renderOptions;
  const { container } = widgetParams;

  if (isFirstRender) {
    container.addEventListener("click", (e) => {
      let el = e.target;
      let hit;

      // If quickshop action
      if (el.closest("[data-product-card-quickshop]")) return;

      // If swatches action
      if (el.closest("[data-product-card-swatches]")) return;

      // If wishlist button
      if (el.closest("[data-wishlist-action]")) return;

      e.preventDefault();

      do {
        if (el instanceof Element && el.matches(".product-card")) {
          hit = el;
          break;
        }
        el = el.parentNode;
      } while (el && el !== container);

      // Stop if hit not found
      if (!hit) return;

      const link = `/products/${hit.dataset.handle}`;

      const clickData = {
        index: hit.dataset.algoliaIndex,
        eventName: `search dropdown - product click`,
        queryID: hit.dataset.algoliaQueryid,
        objectIDs: [hit.dataset.algoliaObjectid],
        positions: [Number(hit.dataset.algoliaPosition)],
        userToken: Cookies.get("_ALGOLIA"),
      };

      // Set the logged in customer user token
      if (window.algolia.customer) {
        clickData.authenticatedUserToken = `${window.algolia.customer}`;
      }

      // Send the click event
      aa("clickedObjectIDsAfterSearch", clickData);

      saveForConversionTracking(clickData);

      window.location.href = link;
    });

    return;
  }

  // Empty container
  container.innerHTML = "";

  // Insert results
  if (hits.length > 0) {
    container.innerHTML = `
      <h5 class="search-dropdown__source-header">${
        container.dataset.resultsTitle
      }</h5>

      <ul class="search-dropdown__items-list list-unstyled is-grid">
        ${hits
          .map(
            (hit) => `
              <li class="search-dropdown__item is-col-6 is-col-4-md is-col-3-xl">
                ${productCardTemplate(hit)}
              </li>
            `
          )
          .join("")}
      </ul>
    `;

    // Insert or update the 'View All Products' button
    if (container.parentNode.querySelector(".search-dropdown__view-all-btn")) {
      container.parentNode.querySelector(
        ".search-dropdown__view-all-btn"
      ).href = `/search?q=${results.query}`;
    } else {
      container.insertAdjacentHTML(
        "afterend",
        `<a href="/search?q=${results.query}" class="button button--tertiary search-dropdown__view-all-btn center">
          View All Products
        </a>`
      );
    }

    // Attach event listeners
    const allProductCards = container.querySelectorAll("[data-product-card]");

    allProductCards.forEach((card) => {
      // Card hover events
      const hoverElem = card.querySelector("[data-product-card-inner]");

      hoverElem.removeEventListener("mouseenter", handleCardHover);
      hoverElem.addEventListener("mouseenter", handleCardHover, { once: true });

      // Swatches click events
      const cardSwatches = card.querySelectorAll(
        "[data-product-card-color-id]"
      );

      cardSwatches.forEach((swatch) => {
        swatch.removeEventListener("click", handleSwatchClick);
        swatch.addEventListener("click", handleSwatchClick);
      });

      if (card.querySelector("[data-show-remaining-colours]")) {
        card
          .querySelector("[data-show-remaining-colours]")
          .addEventListener("click", (e) => {
            e.target.remove();

            card
              .querySelectorAll(".product-card-colors__link--hidden")
              .forEach((el) => {
                el.classList.remove("product-card-colors__link--hidden");
              });
          });
      }
    });
  } else {
    container.innerHTML = `
      <div class="search-dropdown__products-empty">
        <h3>No results found</h3>

        <p class="text-gray">
          Unfortunately we couldn't find any results, please try a different query.
        </p>
      </div>
    `;
  }
};

export const products = window.instantsearch.connectors.connectHits(renderHits);
